function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCheckmarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-ios-checkmark-circle",
    d: "M13.375 3.375a10 10 0 1 0 10 10 10 10 0 0 0-10-10zm5.12 7.236-6.428 6.457a.868.868 0 0 1-.558.264.842.842 0 0 1-.563-.274L8.25 14.365a.192.192 0 0 1 0-.274l.856-.856a.186.186 0 0 1 .269 0l2.135 2.135 5.865-5.909a.19.19 0 0 1 .135-.061.175.175 0 0 1 .135.058l.841.87a.19.19 0 0 1 .014.283z",
    transform: "translate(-3.375 -3.375)",
    style: {
      fill: "#ed3833"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCheckmarkCircle);
export default __webpack_public_path__ + "static/media/red-checkmark-circle.0eb5d65ca3e570a2120fb327d98561ea.svg";
export { ForwardRef as ReactComponent };